module.exports = __webpack_public_path__ + "b8048d459b278540c775ac3a11c8b677.png";